import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import logo from '../assets/images/logo/logo_y.png'; // Adjust path as per your project structure
import '../assets/css/style.css'; // Assuming the original stylesheet is included

const Footer = () => {
  useEffect(() => {
    // jQuery UI Datepicker setup
    if (window.jQuery && window.jQuery.datepicker) {
      window.jQuery.datepicker.setDefaults({
        closeText: "Close",
        currentText: "Today",
        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        nextText: "Next",
        prevText: "Previous",
        dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
        dateFormat: "M d, yy",
        firstDay: 1,
        isRTL: false,
      });
    }

    // Snazzy Maps data (if needed for map integration)
    window.SnazzyDataForSnazzyMaps = {
      id: 15,
      name: "Subtle Grayscale",
      description: "A nice, simple grayscale version of the map with color extremes that are never too harsh on the eyes. Originally created for http://barvinssurvins.fr/situer.",
      url: "https://snazzymaps.com/style/15/subtle-grayscale",
      imageUrl: "https://snazzy-maps-cdn.azureedge.net/assets/15-subtle-grayscale.png?v=20170626083535",
      json: '[{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}]',
      views: 1006718,
      favorites: 2583,
      createdBy: { name: "Paulo Avila", url: null },
      createdOn: "2013-10-30T16:37:24.593",
      tags: ["greyscale", "light"],
      colors: ["gray", "white"],
    };

    // Tourmaster i18n settings
    window.TMi18n = {
      closeText: "Done",
      currentText: "Today",
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
      firstDay: "1",
    };

    // Initialize any required plugins (e.g., mmenu, superfish, flexslider) if used
    // Add initialization code here if needed based on your project setup
  }, []);

  return (
    <footer style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="hotale-footer-wrapper">
        <div className="hotale-footer-container hotale-container clearfix">
          <div className="hotale-footer-column hotale-item-pdlr hotale-column-15">
            <div id="block-21" className="widget widget_block widget_media_image hotale-widget">
              <figure className="wp-block-image">
                <a href="/BananaBunksMirissa">
                  <img loading="lazy" width="110" height="27" src={logo} alt="Banana Bunks Mirissa Logo" className="wp-image-14995" />
                </a>
              </figure>
            </div>
            <div id="block-7" className="widget widget_block widget_text hotale-widget">
              <p></p>
            </div>
            <div id="block-8" className="widget widget_block hotale-widget">
              <p>
                <a href="https://web.facebook.com/profile.php?id=100090580203584" target="_blank" rel="noopener noreferrer">
                  <span className="gdlr-core-space-shortcode" style={{ marginTop: '-10px' }}></span>
                  <FontAwesomeIcon icon={faFacebookF} style={{ fontSize: '16px', color: '#eeb85e', marginLeft: '3px', marginRight: '17px' }} />
                </a>
                <a href="https://www.instagram.com/bananabunksmirissa" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faInstagram} style={{ fontSize: '16px', color: '#eeb85e', marginLeft: '3px', marginRight: '17px' }} />
                </a>
                <a href="https://wa.me/94767008800" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faWhatsapp} style={{ fontSize: '16px', color: '#eeb85e', marginLeft: '3px', marginRight: '17px' }} />
                </a>
              </p>
            </div>
            <div id="block-22" className="widget widget_block widget_text hotale-widget">
              <p></p>
            </div>
          </div>
          <div className="hotale-footer-column hotale-item-pdlr hotale-column-15">
            <div id="block-10" className="widget widget_block hotale-widget">
              <h4 style={{ color: '#eeb85e' }}>Navigation</h4>
            </div>
            <div id="block-14" className="widget widget_block hotale-widget">
              <ul>
                <li><a style={{ color: '#eeb85e' }} href="/">Home</a></li>
                <li><a style={{ color: '#eeb85e' }} href="/bbmirissa/room">Rooms & Bunks</a></li>
                <li><a style={{ color: '#eeb85e' }} href="/bbmirissa/gallery">Gallery</a></li>
                <li><a style={{ color: '#eeb85e' }} href="/bbmirissa/offers">Offers</a></li>
                <li><a style={{ color: '#eeb85e' }} href="/bbmirissa/aboutus">About Us</a></li>
                <li><a style={{ color: '#eeb85e' }} href="/bbmirissa/contactus">Contact Us</a></li>
              </ul>
            </div>
          </div>
          <div className="hotale-footer-column hotale-item-pdlr hotale-column-15">
            <div id="block-10" className="widget widget_block hotale-widget">
              <h4 style={{ color: '#eeb85e' }}>Contact Us</h4>
            </div>
            <div id="block-14" className="widget widget_block hotale-widget">
              <a href="tel:+94767008800">
                <p style={{ color: '#eeb85e' }}><span style={{ color: '#eeb85e' }}>T</span>: +94 76 700 8800</p>
              </a>
              <p className="bbgreen"><span className="gdlr-core-space-shortcode" style={{ marginTop: '-10px' }}></span></p>
              <p>
                <span style={{ color: '#eeb85e' }}>E</span>: <a style={{ color: '#eeb85e' }} href="mailto:reservations@oryzaleisure.com">reservations@oryzaleisure.com</a>
              </p>
              <p><span className="gdlr-core-space-shortcode" style={{ marginTop: '-10px' }}></span></p>
            </div>
          </div>
          <div className="hotale-footer-column hotale-item-pdlr hotale-column-15">
            <div id="block-12" className="widget widget_block hotale-widget">
              <h4 style={{ color: '#eeb85e' }}>Hotel Address</h4>
            </div>
            <div id="block-15" className="widget widget_block hotale-widget">
              <p style={{ color: '#eeb85e' }}>
                73 A, Mahena Rd, Bandaramulla, Mirissa, Sri Lanka 81740
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="hotale-copyright-wrapper">
        <div className="hotale-copyright-container hotale-container clearfix">
          <div className="hotale-copyright-left hotale-item-pdlr greencolor">
            © 2025 Oryza Leisure. All Rights Reserved. Designed and Developed by <a href="https://ollcode.com" target="_blank" rel="noopener noreferrer"><b>Ollcode</b></a>
          </div>
          <div className="hotale-copyright-right hotale-item-pdlr">
            <div style={{ textTransform: 'uppercase', fontWeight: 500, fontSize: '13px', letterSpacing: '3px' }}>
              <a href="/privacy-policy" style={{ marginRight: '22px' }}>Privacy Policy</a>
              <a href="/terms-and-conditions">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;